import { Box, Divider, Link, styled } from '@mui/material';

export const AvatarDesignStyled = styled(Box)({
  '& svg': {
    width: '2.5rem !important',
    height: '2.5rem !important',
  },
});

export const NoAvatarIconStyled = styled(Box)({
  '& svg': {
    width: '2.5rem !important',
    height: '2.5rem !important',
  },
});

export const SSODividerStyled = styled(Divider)(({ theme }) => ({
  marginRight: '20rem',
  marginTop: 'auto',
  [theme.breakpoints.down('sm')]: {
    marginRight: 'auto',
    marginTop: theme.spacing(3),
  },
}));

export const OpenNewTabStyled = styled(Link)(({ theme }) => ({
  fontWeight: 600,
  [theme.breakpoints.down('sm')]: {
    position: 'absolute',
    bottom: '2rem',
    left: '5rem',
  },
}));

export const DisabledOpenNewTabStyled = styled(Link)(({ theme }) => ({
  pointerEvents: 'none',
  color: '#808080',
  cursor: 'not-allowed',
  [theme.breakpoints.down('sm')]: {
    position: 'absolute',
    bottom: '2rem',
    left: '5rem',
  },
}));
